import { render, staticRenderFns } from "./jobCollectItem.vue?vue&type=template&id=e996271a&scoped=true"
import script from "./jobCollectItem.vue?vue&type=script&lang=js"
export * from "./jobCollectItem.vue?vue&type=script&lang=js"
import style0 from "./jobCollectItem.vue?vue&type=style&index=0&id=e996271a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e996271a",
  null
  
)

export default component.exports